/**
 * Mock Data: Top Transactions City Table
 * Mock data for top 5 transactions per city
 *
 * Corresponds to Postman endpoint: GET /product/api/v1/dashboard/city-transactions
 */

import type { CityTransactionsApiResponse, CityTransactionData } from '../data/remote/response';

// Re-export types from response module for backward compatibility
export type { CityTransactionData, CityTransactionsApiResponse } from '../data/remote/response';

// Legacy aliases for backward compatibility
export type TopTransactionsCityData = CityTransactionData;
export type CityTransactionsResponse = CityTransactionsApiResponse;

export const mockTopTransactionsCityData: CityTransactionsApiResponse = {
  data: [
    {
      city: "Jakarta",
      totalTransaction: 1000000,
    },
    {
      city: "Bogor",
      totalTransaction: 850000,
    },
    {
      city: "Depok",
      totalTransaction: 720000,
    },
    {
      city: "Tangerang",
      totalTransaction: 680000,
    },
    {
      city: "Bekasi",
      totalTransaction: 550000,
    },
  ],
  meta: {
    code: "20000",
    message: "OK",
  },
};
